import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQsPage() {
  const faqs = [
    {
      id: 'children',
      question: 'Are children invited?',
      answer:
        'We are only able to accommodate the guests named on your invitation. If children are included, their names will appear on the invitation.',
    },
    {
      id: 'dress-code',
      question: 'What is the dress code?',
      answer:
        "Friday's welcome reception is casual. Saturday's ceremony and reception are Black Tie Optional. Tuxedos and floor-length gowns are welcome, as are dark suits and formal attire.",
    },
    {
      id: 'arrival',
      question: 'When should I arrive for the ceremony?',
      answer:
        'The ceremony will begin promptly at 5:00 p.m. Please arrive by 4:45 p.m. to allow time for seating.',
    },
    {
      id: 'transportation',
      question: 'Will transportation be provided?',
      answer:
        'Transportation will not be provided. Rideshare and taxi services are readily available throughout Baltimore, and most of our recommended hotels are within approximately two miles of the George Peabody Library.',
    },
    {
      id: 'parking',
      question: 'Is there parking at the venue?',
      answer:
        'The George Peabody Library does not have on-site parking. There are several public garages within a 5-minute walk.',
    },
    {
      id: 'rsvp',
      question: 'How do I RSVP?',
      answer:
        'Formal invitations and online RSVP instructions will be sent at a later date. No response is needed at this time.',
    },
  ];

  return (
    <div data-testid="faqs-page">
      <header className="page-hero">
        <div className="page-hero__inner">
          <div>
            <p className="eyebrow text-olive mb-4">Wedding information</p>
            <h1 className="page-title">FAQs</h1>
          </div>
          <p className="max-w-md text-xl leading-snug text-forest/75 md:text-right">
            The details you’ll want before the weekend begins.
          </p>
        </div>
      </header>

      <section className="py-10 md:py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Accordion type="single" collapsible className="space-y-0">
            {faqs.map((faq) => (
              <AccordionItem
                key={faq.id}
                value={faq.id}
                className="faq-item border-b border-forest/20"
                data-testid={`faq-item-${faq.id}`}
              >
                <AccordionTrigger
                  className="faq-trigger py-6 text-left text-[1.35rem] md:text-[1.5rem] text-forest hover:no-underline"
                  data-testid={`faq-trigger-${faq.id}`}
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent
                  className="faq-content pb-7 text-[1.12rem] md:text-[1.2rem] text-forest/70 leading-relaxed"
                  data-testid={`faq-content-${faq.id}`}
                >
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
